//import { mainnet, goerli, sepolia } from 'wagmi/chains'
//import { Chain } from 'wagmi'

// https://hyperliquid.gitbook.io/hyperliquid-docs/onboarding/how-to-use-the-hyperevm
export const hyperliquid = {
  id: 999,
  name: 'Hyperliquid EVM',
  network: 'hyperliquid',
  nativeCurrency: {
    decimals: 18,
    name: 'Hype',
    symbol: 'HYPE',
  },
  rpcUrls: {
    default: { http: ['https://rpc.hyperliquid.xyz/evm'] },
    public: { http: ['https://rpc.hyperliquid.xyz/evm'] },
  },
  blockExplorers: {
    etherscan: { name: 'Block Explorer', url: 'https://hyperliquid.cloud.blockscout.com' },
    default: { name: 'Block Explorer', url: 'https://hyperliquid.cloud.blockscout.com' },
  }
} 

export function abbreviateAddress(address: string, charsLength: number = 4): string {
  if (typeof address !== 'string') return '';
  if (address.length < charsLength * 2 + 2) return address;

  const prefix = address.substr(0, charsLength + 2); // '0x' + charsLength characters
  const suffix = address.substr(-charsLength);

  return `${prefix}...${suffix}`;
}

export const baseTestChain = {
  id: 84532,
  name: 'Base Sepolia',
  network: 'basesepolia',
  nativeCurrency: {
    decimals: 18,
    name: 'Ethereum',
    symbol: 'ETH',
  },
  rpcUrls: {
    public: { http: ['https://sepolia.base.org'] },
    default: { http: ['https://sepolia.base.org'] },
  },
  blockExplorers: {
    etherscan: { name: 'Block Explorer', url: 'https://sepolia.basescan.org' },
    default: { name: 'Block Explorer', url: 'https://sepolia.basescan.org' },
  }
} 


const getEtherScan = () => {
  switch (chain.network) {
    case "blast":  return "https://blastscan.io";
    case "blastsepolia":  return "https://testnet.blastscan.io";
    case "basesepolia":  return "https://sepolia.basescan.org";
    case "sepolia":  return "https://sepolia.etherscan.io";
    case "goerli":  return "https://goerli.etherscan.io";
    case "hyperliquid":  return "https://hyperliquid.cloud.blockscout.com";
  }
}
export const chain = hyperliquid; // <-- MAINNET SET LIVE
//export const chain = blastTestnetChain; // testnet
//export const chain = blastTestnetChain; // testnet

export const getEtherscanAddressLink = (hash) => {
  return `${getEtherScan()}/address/${hash}`;
}

export const getEtherscanTxnLink = (hash) => {
  return `${getEtherScan()}/tx/${hash}`;
}

export const getEtherscanContractLink = (hash) => {
  return `${getEtherScan()}/address/${hash}`;
}

console.log(`Chain: ${chain.name} (${chain.id})`)
console.log(`Contract: ${getEtherscanContractLink(process.env.REACT_APP_CONTRACT_FRONTEND)}`)


export const links = {
  twitter: "https://x.com/dailofrog",
  twitterGoop: "https://x.com/goopgoop_art",
  discord: "https://discord.gg/KBAbk2a4PM",
  contractFrontEnd: getEtherscanContractLink(process.env.REACT_APP_CONTRACT_FRONTEND),
  hyperliquid: "https://hyperliquid.xyz/",
  blurStore: "https://blur.io/",
  opensea: "https://opensea.io/collection/gems/",
  elementStore: "https://element.market/collections/gems",
  blur: "https://blur.io/blast/collection/gems",
  net: "https://www.netprotocol.app/app/bazaar/hyperliquid/0xDD59aC38cb15F688c18909bA1Ca708A76cC351F5",
  driptrade: "https://app.drip.trade/collections/gems",
};
